import React, { useState } from "react";
import { Button, Container, Row } from "reactstrap";

const style = {
  list: {
    listStyle: 'none',
    textAlign: 'center',
    cursor: 'pointer',
    padding:0
  }
}

const FooterAction = (props) => {

  return (
    <ul style={style.list} >
      <li onClick={props.handleIndicadores}>INDICADORES</li>
      <li onClick={props.handleRelatorios}>RELATÓRIOS</li>
      <li onClick={props.handlePaineisControle}>PAINÉIS DE CONTROLE</li>
      <li onClick={props.handleMapas}>MAPAS</li>
      <li onClick={props.handleFaleConosco}>FALE CONOSCO</li>
    </ul>
  );
};

export default FooterAction;
